import axios, { AxiosRequestConfig } from 'axios';
import { useAuth } from '@hiiretail/core';

export const useTokenInterceptor: () => Promise<void> = async () => {
  const { currentUser } = useAuth();
  const tokenInterceptor = async (request: AxiosRequestConfig) => {
    const token = await currentUser?.getIdToken();
    request.headers['Authorization'] = `Bearer ${token}`;
    return request;
  };
  axios.interceptors.request.use(tokenInterceptor);
};
